<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.container {
  .title {
    margin-bottom: 10vh;
  }
  .form {
    margin-bottom: 10vh;
  }
}
</style>

<template>
  <div class="container">
    <h2 class="title">易可印运维</h2>
    <div class="form">
      <mt-field
        label="手机号"
        placeholder="请输手机号"
        v-model.trim="tel"
      ></mt-field>
      <mt-field
        label="密码"
        placeholder="请输入密码"
        v-model.trim="password"
        type="password"
      ></mt-field>
    </div>
    <mt-button @click.native="login" class="btn">登录</mt-button>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { accountLogin } from "../../service";
export default {
  name: "Login",
  data() {
    return {
      tel: "",
      password: ""
    };
  },
  methods: {
    ...mapMutations("user", ["recordUser", "recordGroups"]),
    async login() {
      const {
        data: { code, msg, data }
      } = await accountLogin(this.tel, this.password);
      if (code === 0) {
        this.recordUser({ token: data.token, user: data.user });
        this.$router.push("/operation/home");
      } else {
              alert(msg)
      }
    }
  },
  computed: {
    //判断手机号码
    rightPhoneNumber: function() {
      return /^1\d{10}$/gi.test(this.tel);
    }
  },
  mounted() {
    // console.log('mounted');
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Login/index.vue